import { Box, keyframes, useTheme } from "@mui/material";

interface SegmentedSpinnerProps {
	size?: number;
	color?: string;
	segments?: number;
}

export const SegmentedSpinner = ({
	size = 64,
	color = "#000",
	segments = 8,
}: SegmentedSpinnerProps) => {
	const theme = useTheme();
	const segmentArray = Array.from(
		{ length: segments },
		(_, segmentIndex) => segmentIndex,
	);
	const animationDuration = 1;

	const createSegmentAnimation = (index: number) => {
		const frames: string[] = [];
		for (let step = 0; step < segments; step++) {
			const percent = (step / segments) * 100;
			const invisibleSegment = step % segments;
			const distance = (index - invisibleSegment + segments) % segments;
			const opacity =
				index === invisibleSegment ? 0 : distance / (segments - 1);
			frames.push(`${percent.toFixed(1)}% { opacity: ${opacity.toFixed(2)}; }`);
		}
		const invisibleSegment = 0;
		const distance = (index - invisibleSegment + segments) % segments;
		const opacity = index === invisibleSegment ? 0 : distance / (segments - 1);
		frames.push(`100% { opacity: ${opacity.toFixed(2)}; }`);
		return keyframes`${frames.join("\n")}`;
	};

	return (
		<Box width={size} height={size} position="relative">
			{segmentArray.map((index) => {
				const rotation = (index * 360) / segments;
				const segmentAnimation = createSegmentAnimation(index);

				return (
					<Box
						key={index}
						position="absolute"
						width="10%"
						height="30%"
						left="45%"
						top="0%"
						borderRadius={theme.radii.full}
						sx={{
							background: color,
							transformOrigin: "50% 166%",
							transform: `rotate(${rotation}deg)`,
							animation: `${segmentAnimation} ${animationDuration}s linear infinite`,
						}}
					/>
				);
			})}
		</Box>
	);
};
